let scrollToIgnore = null
export const syncScroll = (target, main, alertsLength, temp, num) => {
  if(main == scrollToIgnore) {
    scrollToIgnore = null
    return;
  }
  scrollToIgnore = target
  
let targetElement = document.getElementById(target);

let mainElement = document.getElementById(main);

let mainElementScrollTop = document.getElementById(main).scrollTop;

let listLength = alertsLength * 31;

let visibleListLength = mainElement.offsetHeight;

let scrollTop = listLength - visibleListLength + 30;

targetElement.scrollTop = mainElementScrollTop;

};